//user management actions
export const SEND_BUSINESS_INVITE = 'SEND_BUSINESS_INVITE';
export const GET_BUSINESS_INVITE = 'GET_BUSINESS_INVITE';
export const FINALIZE_BUSINESS_INVITE = 'FINALIZE_BUSINESS_INVITE';
export const CREATE_BUSINESS_USER = 'CREATE_BUSINESS_USER';
export const DELETE_INVITE_ITEM = 'DELETE_INVITE_ITEM';
